import { reduce } from 'lodash';
import getProviderLatLng from './getProviderLatLng';

function getResultBounds(providers, currentBounds, google) {
  const bounds = reduce(providers, (acc, provider) => {
    const latLng = getProviderLatLng(provider);
    if (!latLng.lat || !latLng.lng) {
      return acc;
    }
    if (!acc) {
      return new google.maps.LatLngBounds(latLng);
    }
    return acc.extend(latLng);
  }, currentBounds);
  return bounds;
}

export default getResultBounds;



// WEBPACK FOOTER //
// ./public/js/utils/getResultBounds.js